<template>
  <div class="vb-notice" :style="{ '--vb-notice-color': notice_color }">
    <div v-if="icon" class="vb-notice__icon">
      <vb-icon :name="icon" :color="notice_color" :size="20" />
    </div>

    <div class="vb-notice__content">
      <p v-if="title" class="vb-notice__title">{{ title }}</p>
      <div class="vb-notice__text">
        <slot>{{ text }}</slot>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'vb-notice',

    props: {
      icon: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
      text: {
        type: String,
        default: '',
      },
      color: {
        type: String,
        default: '',
      },
    },

    computed: {
      notice_color() {
        return this.color || this.sass('primary');
      },
    },
  };
</script>

<style lang="scss" scoped>

  .vb-notice {
    display: flex;
    align-items: flex-start;
    padding: $grid-gutter-20;
    background: $selected;
    border: $border-width solid #e2eaf7;
    border-radius: $border-radius-lg * 3;

    &__icon {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      margin-right: 16px;
      background-color: #deecff;
      border-radius: 50%;
    }

    &__title {
      margin: 0;
      font-size: $font-size-md;
      font-weight: $vb-font-weight-semibold;
      line-height: 20px;
      color: var(--vb-notice-color);
    }

    &__text {
      margin: ($grid-gutter-width / 6) 0 0;
      font-size: $font-size-md;
      line-height: normal;
      color: $gray-900;

      // paragrafi passati nello slot
      ::v-deep p {
        margin: 0;

        & + p {
          margin-top: $grid-gutter-width / 3;
        }
      }
    }
  }
</style>
